import React, { createContext, useState } from 'react'
import { v4 as uuidv4 } from 'uuid'
import merge from 'lodash/merge'
import NotificationWrapper from './Notification'
import { NotificationOptionsType } from './Notification.types'
import BannerWrapper from './Banners'

type NotificationContextType = {
    state: any
    addBanner: any
    add: any
    addError: any
    addSuccess: any
    remove: any
    notifications: any
    banners: any
    removeBanner: any
    deleteBanner: any
}

export const NotificationContext = createContext<NotificationContextType>(null)

class NotificationProvider extends React.Component<any, any> {
    constructor(props) {
        super(props)

        this.state = {
            notifications: [],
            banners: [],
        }
    }

    addBanner = (options: any = {}) => {
        options['id'] = uuidv4()
        this.setState((prevState) => {
            const banners = prevState.notifications.slice()
            banners.push(options)
            return { banners }
        })
        return options.id
    }

    add = (options) => {
        options['id'] = uuidv4()
        this.setState((prevState) => {
            const notifications = prevState.notifications.slice()
            notifications.push(options)
            return { notifications }
        })
    }

    addError = (options: NotificationOptionsType) => {
        const id = uuidv4()
        const defaultOptions = {
            id,
            title: 'Error',
            type: 'error',
            message: 'Your request could not be completed',
            hideAfter: 3000,
        }
        options = merge(defaultOptions, options)
        this.add(options)
    }

    addSuccess = (options: NotificationOptionsType) => {
        const id = uuidv4()
        const defaultOptions = {
            id,
            title: 'Success',
            type: 'success',
            message: 'Your request was successfully completed',
            hideAfter: 3000,
        }
        options = merge(defaultOptions, options)
        this.add(options)
    }

    updateNotification = (id, update) => {
        this.setState((prevState) => {
            const notifications = prevState.notifications

            return {
                notifications: notifications.map((n) => {
                    if (n.id === id) {
                        n = merge(n, update)
                    }
                    return n
                }),
            }
        })
    }

    remove = (id) => {
        // const notification = this.state.notifications.find((n) => n.id !== id)
        //
        // if (notification) {
        //     this.updateNotification(id, { remove: true })
        // }
        this.setState((prevState) => {
            return { notifications: prevState.notifications.filter((n) => n.id !== id) }
        })
    }

    removeBanner = (id) => {
        this.setState((prevState) => {
            return {
                banners: prevState.banners.map((n) => {
                    if (n.id === id) {
                        n.shallRemove = true
                    }
                    return n
                }),
            }
        })
    }

    deleteBanner = (id) => {
        this.setState((prevState) => {
            return { banners: prevState.banners.filter((n) => n.id !== id) }
        })
    }

    render() {
        const { children } = this.props
        const ctx: NotificationContextType = {
            state: this.state,
            add: this.add,
            addBanner: this.addBanner,
            addError: this.addError,
            addSuccess: this.addSuccess,
            remove: this.remove,
            banners: this.state.banners,
            removeBanner: this.removeBanner,
            deleteBanner: this.deleteBanner,
            notifications: this.state.notifications,
        }

        return (
            <NotificationContext.Provider value={ctx}>
                {children}
                <NotificationWrapper />
                <BannerWrapper />
            </NotificationContext.Provider>
        )
    }
}

export default NotificationProvider
